import { gql } from '@apollo/client';
import CommonFragments from 'features/common/fragments';

export const FINANCIAL_PRODUCT_RULE_FILTERS_UPDATED = gql`
  subscription financialProductRuleFiltersUpdated($ruleId: Int!) {
    financialProductRuleFiltersUpdated(ruleId: $ruleId) {
      ruleId
      headers {
        ...messageHeaders
      }
    }
  }
  ${CommonFragments.messageHeaders}
`;
